import React, { type FC } from "react";
import { useModuleBEM, useSelfServeStyles } from "@b2bportal/core-themes";
import { CoreSelfServeComponent } from "@b2bportal/core-types";
import { phoneWithSupportIdIfEnabled } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";

import defaultStyles from "./ContactSupportModalContent.module.scss";

export interface IContactSupportModalContentProps {
  bookingSupportId?: string;
}

export const ContactSupportModalContent: FC<
  IContactSupportModalContentProps
> = ({ bookingSupportId }) => {
  const { t, brand: branding } = useI18nContext();
  const COMPONENT_KEY = CoreSelfServeComponent.ContactSupportModalContent;
  const styles = useSelfServeStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const hideSupportId =
    branding.contactSupport.hideSupportIdInContactSupport ?? false;
  const supportPhone = phoneWithSupportIdIfEnabled(
    hideSupportId,
    branding.contactSupport.supportNumber,
    bookingSupportId
  );
  const supportPhoneIntl = phoneWithSupportIdIfEnabled(
    hideSupportId,
    branding.contactSupport.intlSupportNumber,
    bookingSupportId
  );

  return (
    <div className={cn("call-modal-content")}>
      <div className={cn("call-modal-text")}>
        {t("customerSupportPage.landingPage.speakDialogCopy")}
      </div>
      {hideSupportId ? null : (
        <div className={cn("support-id")}>{`${t(
          "customerSupportPage.landingPage.supportId"
        )}: ${bookingSupportId}`}</div>
      )}
      <div className={cn("call-modal-text")}>
        {t("customerSupportPage.landingPage.phoneDomesticCopy")}
        <a href={`tel:${supportPhone}`}>
          {branding.contactSupport.displaySupportNumber}
        </a>
      </div>
      <div className={cn("call-modal-text")}>
        {t("customerSupportPage.landingPage.phoneInternationalCopy")}
        <a href={`tel:${supportPhoneIntl} `}>
          {branding.contactSupport.displayIntlSupportNumber}
        </a>
      </div>
    </div>
  );
};
